export const MAIN_ADDRESS = 'MAIN_ADDRESS_';